module.exports = __webpack_public_path__ + "571c3784c157c2891bcf045255248966.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/spacemarines-vignette-preview-420.jpg
// module id = 545
// module chunks = 0